import "src/decidim/assemblies/assemblies"

// Images
require.context("../images", true)
